// acceptanceDocumentContent — support for CU1/CU2/CU5 (story #73, S1/S2/S4-S6/S20): fetches a PDF
// binary from Sun as a blob, resolving its original filename from the Content-Disposition header
// (RN1/RN2/RN10 — "con su nombre de fichero y tipo de contenido originales"). `Blob.type` already
// carries the original content type (set by `Response.blob()` from the response's Content-Type
// header), so only the filename needs manual parsing here. Shared by the signed-document
// viewer/download (CU1), the issued/signed pairing view (CU2) and the per-attempt mail-history
// download (CU5).
import { apiGetFile } from '../generic/Api_Functions'

const FALLBACK_FILENAME = 'document.pdf'

// The Content-Disposition header is read at the API boundary: Sun may genuinely omit it (older
// backend, misconfigured proxy), so a missing/empty header is the legitimate `null`-like case this
// helper falls back from (CLAUDE.md allows this at API boundaries).
export const extractFilenameFromContentDisposition = (headerValue, fallback = FALLBACK_FILENAME) => {
  if (!headerValue) return fallback
  const encodedMatch = /filename\*=UTF-8''([^;]+)/i.exec(headerValue)
  if (encodedMatch) return decodeURIComponent(encodedMatch[1])
  const plainMatch = /filename="?([^";]+)"?/i.exec(headerValue)
  return plainMatch ? plainMatch[1] : fallback
}

export const fetchAcceptanceDocumentContent = async (path, fallbackFilename = FALLBACK_FILENAME) => {
  const response = await apiGetFile(path)
  const blob = await response.blob()
  const filename = extractFilenameFromContentDisposition(response.headers.get('content-disposition'), fallbackFilename)
  return { blob, filename }
}

// RN1/RN2/RN10 — download with the original filename/content type: `Blob.type` (content type)
// travels automatically; the filename is resolved above. Same blob+link pattern already used by
// `apiDownloadFile` (`Api_Functions.jsx`), which this does not reuse directly because it needs the
// filename resolved dynamically per response instead of a caller-fixed name.
export const downloadAcceptanceDocument = async (path, fallbackFilename = FALLBACK_FILENAME) => {
  const { blob, filename } = await fetchAcceptanceDocumentContent(path, fallbackFilename)
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = filename
  link.click()
  window.URL.revokeObjectURL(link.href)
}
